export const ReactionTestIds = {
  fieldReactionBar: 'field_reaction-bar'
} as const;
